<template>
    <div id="ChatHistoryDetail">
        <div class="detail-container">
            <div class="message-list-wrapper">
                <vue-scroll id="vueScroll" ref="vs" :ops="vuescrollOptions">
                    <MessageList
                        :alwaysScrollToBottom="true"
                        :colors="colors"
                        :messageStyling="messageStyling"
                        :messages="messages"
                        :participants="participants"
                        :scrollVS="$refs['vs']"
                        :showTypingIndicator="''"
                        :conversation-terminated="true"
                    >
                        <template v-slot:user-avatar="scopedProps">
                            <slot :message="scopedProps.message" :user="scopedProps.user" name="user-avatar"></slot>
                        </template>
                        <template v-slot:text-message-body="scopedProps">
                            <slot
                                :me="scopedProps.me"
                                :message="scopedProps.message"
                                :messageColors="scopedProps.messageColors"
                                :messageText="scopedProps.messageText"
                                name="text-message-body"
                            >
                            </slot>
                        </template>
                        <template v-slot:system-message-body="scopedProps">
                            <slot :message="scopedProps.message" name="system-message-body"></slot>
                        </template>
                        <template v-slot:text-message-toolbox="scopedProps">
                            <slot :me="scopedProps.me" :message="scopedProps.message" name="text-message-toolbox">
                            </slot>
                        </template>
                    </MessageList>
                </vue-scroll>
            </div>
        </div>
    </div>
</template>
<script>
import MessageList from "./popup-chat/MessageList";

export default {
    name: "ChatHistoryDetail",
    props: {
        vuescrollOptions: {
            type: Object,
        },
        colors: {
            type: Object,
        },
        messageStyling: {
            type: Boolean,
        },
        participants: {
            type: Array,
            default: [],
        },
        messages: { default: [] },
    },
    components: { MessageList },
    data() {
        return {};
    },
    mounted() {},
};
</script>
<style></style>



// WEBPACK FOOTER //
// src/components/V2/ChatHistoryDetail.vue